import { styled } from '@spazious/dollhouse-theme';

// Pending to be implemented

export type PaginationProps = Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'> & {
  count: number;
  page: number;
  disabled?: boolean;
  onChange: (event: any, page: number) => void;
};
export const Pagination = styled.div<PaginationProps>``;
